import React, { Component } from 'react';
import moment from 'moment';

// css
import './styles.css';

export default class MapTimer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialTime: this.props.totalTime,
      counter: this.props.totalTime, // ms
      tick: 1000, // ms
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this._updateCounter();
    }, this.state.tick);
  }

  // -disable-next-line react/sort-comp
  _updateCounter = () => {
    if (this.state.counter > 0) {
      this.setState({
        counter: this.state.counter - 1000,
      });
    } else {
      this.setState({
        counter: this.state.initialTime,
      });

      this.props.onUpdate();
    }
  };

  _renderFormattedCounter = () => {
    let counterMinutes = moment
      .duration(this.state.counter)
      .minutes()
      .toString();
    let counterSeconds = moment
      .duration(this.state.counter)
      .seconds()
      .toString();

    if (counterMinutes.length === 1) {
      counterMinutes = `0${counterMinutes}`;
    }

    if (counterSeconds.length === 1) {
      counterSeconds = `0${counterSeconds}`;
    }

    return `${counterMinutes}:${counterSeconds}`;
  };

  _calculateProgressBarWidth = () => {
    const currentTime = this.state.counter;
    const totalTime = this.state.initialTime;

    const widthPercent = (currentTime * 100) / totalTime;

    return `${widthPercent}%`;
  };

  componentWillUnmount() {
    clearInterval(this.interval);

    this.setState({
      counter: this.state.initialTime,
    });
  }

  render() {
    return (
      <div className="MapTimer">
        <div className="MapTimer__status-text">
          Próxima atualização em {this._renderFormattedCounter()}
        </div>

        <div
          style={{
            width: this._calculateProgressBarWidth(),
          }}
          className="MapTimer__progress-bar"
        />
      </div>
    );
  }
}
